import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';

// 헤더 스타일 컴포넌트
const HeaderItem = ({ xs, label }) => (
  <Grid item xs={xs} align="center">
    <Typography sx={{ fontWeight: 'bold', color: '#333', fontSize: '0.9rem', lineHeight: '32px' }}>
      {label}
    </Typography>
  </Grid>
);

// 데이터 스타일 컴포넌트
const DataItem = ({ xs, value, color = 'text.primary' }) => (
  <Grid item xs={xs} align="center">
    <Typography 
      sx={{ 
        fontSize: '0.95rem', 
        color: color, 
        lineHeight: '32px', 
        whiteSpace: 'nowrap', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
        px: 0.5 
      }}
    >
      {value || '-'}
    </Typography>
  </Grid>
);

const OrderBookSummary = ({ orderInfo, approvalList }) => {
  const [finalApproveDate, setFinalApproveDate] = useState('');

  useEffect(() => {
    if (approvalList && approvalList.length > 0) {
      const length = approvalList.length;
      const docuDt = approvalList[length - 1]['docuDt'];
      setFinalApproveDate(docuDt);
    }
  }, [approvalList]);

  // 상태값에 따른 텍스트 및 색상 매핑
  const getStatus = (yn) => {
    if (yn === 'S') return { text: '진행중', color: '#1976d2' };
    if (yn === 'Y') return { text: '완료', color: '#2e7d32' };
    if (yn === 'N') return { text: '미결재', color: '#d32f2f' };
    return { text: '-', color: 'text.secondary' };
  };

  const status = getStatus(orderInfo?.ordYn);

  return (
    <Box sx={{ width: '100%' }}>
      {/* 헤더 영역: 회색 배경 및 슬림 높이 */}
      <Grid 
        container 
        sx={{ 
          height: '32px', 
          bgcolor: '#f1f3f5', 
          borderBottom: '1px solid #dee2e6',
          alignItems: 'center'
        }}
      >
        <HeaderItem xs={2.5} label="문서번호" />
        <HeaderItem xs={1.5} label="문서명" />
        <HeaderItem xs={2.5} label="작성일자" />
        <HeaderItem xs={1.5} label="작성자" />
        <HeaderItem xs={1.5} label="결재상태" />
        <HeaderItem xs={2.5} label="최종승인일자" />
      </Grid>

      {/* 데이터 영역: 흰색 배경 및 텍스트 정렬 */}
      <Grid 
        container 
        sx={{ 
          height: '32px', 
          alignItems: 'center', 
          bgcolor: '#fff' 
        }}
      >
        <DataItem xs={2.5} value={orderInfo?.roNo} />
        <DataItem xs={1.5} value="수주품의서" />
        <DataItem xs={2.5} value={orderInfo?.crtDt} />
        <DataItem xs={1.5} value={orderInfo?.crtNm} />
        <DataItem xs={1.5} value={status.text} color={status.color} />
        <DataItem xs={2.5} value={finalApproveDate} />
      </Grid>
      <Divider />
    </Box>
  );
};

export default OrderBookSummary;
